<script lang="ts">
import Button from "../../materialize/components/Button.svelte";
import {push} from 'svelte-spa-router';
import { auth_token } from "../../stores/stores";
import Authentication from "../subcomponents/Authentication.svelte";
import Row from "../../materialize/grid/Row.svelte";
import Column from "../../materialize/grid/Column.svelte";
import Container from "../../materialize/grid/Container.svelte";
</script>
<Authentication></Authentication>
{#if $auth_token}
    <Container>
        <Row>
            <h1>Gestione registrazioni</h1>
            <Column small={12} medium={6}>
                <Button on:click={()=>{push("/contribute/audio/random")}}>Aggiungi audio a parola casuale</Button>
            </Column>
        </Row>
    </Container>


{/if}
